// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h1[data-v-fc021b74]{font-size:20px}.app[data-v-fc021b74]{position:absolute;left:0;padding:1em;margin:0;width:100%}", ""]);
// Exports
module.exports = exports;
